<template>
  <v-btn text @click="openDetailClickAction" class="open-detail-button" min-width="100%">
    <v-icon color="#74B8BE" v-if="isOpenDetail">mdi-arrow-up-drop-circle-outline</v-icon>
    <v-icon color="#74B8BE" v-else>mdi-arrow-down-drop-circle</v-icon>
  </v-btn>
</template>

<script>

export default {
  name: "CheckListItemOpenButton",
  data: () => ({
  }),
  methods: {
    openDetailClickAction() {
      this.$emit('openDetailClickAction')
    }
  },
  created() {
  },
  components: {
  },
  props: ['isOpenDetail']
};

</script>

<style scoped>
.open-detail-button {
  width: 10%;
  padding: 0 10px 0 10px !important;
}
</style>
